import React from 'react';
import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './PaymentRequestView.st.css';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';

export enum PaymentRequestViewDataHooks {
  title = 'PaymentRequestViewDataHooks.title',
  subtitle = 'PaymentRequestViewDataHooks.subtitle',
}

export interface PaymentRequestViewProps {
  dataHook: string;
  title: string;
  subtitle: string;
}

export const PaymentRequestView = ({dataHook, title, subtitle}: PaymentRequestViewProps) => {
  const {experiments} = useExperiments();
  const fixPaymentRequestViewCss = experiments.enabled(SPECS.FixPaymentRequestViewCss);

  return (
    <div
      data-hook={dataHook}
      className={fixPaymentRequestViewCss ? classes.root : /* istanbul ignore next */ classes.rootOld}>
      <div>
        <Text
          data-hook={PaymentRequestViewDataHooks.title}
          typography={TextTypography.largeTitle}
          className={classes.title}>
          {title}
        </Text>
      </div>
      <Text data-hook={PaymentRequestViewDataHooks.subtitle} className={classes.subtitle}>
        {subtitle}
      </Text>
    </div>
  );
};
